import templateUrl from './edit-commission-policy-abstract.component.html';

/**
 * An abstract form of a commission policy that determines how commissions
 * interact with other systems in Apex.
 */
export const EditCommissionPolicyAbstractComponent = {
    // TODO: Merge in with apex-edit-commission-policy under isAbstract binding.
    // This component allows editing the abstract properties of a commission policy without being applied to a specific program.
    templateUrl,
    controller: class {
        constructor() {
            // If true, the commission policy does not apply to a concrete program.
            this.isAbstract = true;
        }

        onChange() {
            if (this.commissionPolicyForm) {
                this.commissionPolicyForm.$setDirty(true);
            }
        }
    },
    controllerAs: "vm",
    require: {
        commissionPolicyForm: "?^^form"
    },
    bindings: {
        commissionPolicy: "<",
        isOverride: "<?"
    }
}
